(function(win) {
  var _this = this;
  var scrollSection = {};
  var $loadButton = $('.load');
  var currentPage = 1;
  var param;
  window.location.href.indexOf("sections") > -1 ? param = window.location.href.split("sections").pop() + '&' : param = '?';
  scrollSection.init = function() {
    $loadButton.on('click', function() {
      var url = 'https://${host}/m/new_posts${param}&page=${page}';
      url = url.replace('${host}', location.hostname).replace('${page}', currentPage + 1).replace('${param}&', param);
      $.ajax({
        url: url,
        type: 'GET',
        dataType: 'html',
        beforeSend: function () {
          $('.div').addClass('active');
        }
      })
      .done(function(_html) {
        var posts = $(_html).find('[data-list-posts]');
        $('.wrapper-posts').append(posts);
        $('.div').removeClass('active');
        if ($(_html).find('.post').length < 10) {
          $loadButton.css("display", "none");
        }
        currentPage++;
      })
    });
  }
  win.scrollSection = scrollSection
})(window)
scrollSection.init();
